var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#f6f7f9"},attrs:{"id":"app"}},[_c('router-view'),_c('el-backtop',{attrs:{"visibility-height":240,"right":100,"bottom":100}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }